import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "@/lib/cn";

import { renderFieldLabel } from "./fieldLabel";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
  hint?: string;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, hint, className, id, ...props },
  ref,
) {
  const inputId =
    id ?? props.name ?? (label ? label.toLowerCase().replace(/\s+/g, "-") : undefined);

  return (
    <label className="flex min-w-0 flex-1 flex-col gap-1.5" htmlFor={inputId}>
      {label ? renderFieldLabel(label) : null}
      <input
        ref={ref}
        id={inputId}
        className={cn(
          "h-11 w-full rounded-xl border bg-surface-raised px-3.5 text-sm text-ink",
          "placeholder:text-muted/70",
          "focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20",
          error ? "border-danger" : "border-line",
          className,
        )}
        {...props}
      />
      {error ? <span className="text-xs text-danger">{error}</span> : null}
      {!error && hint ? <span className="text-xs text-muted">{hint}</span> : null}
    </label>
  );
});
